export default __webpack_public_path__ + "static/media/PromDate400.e6571cb1.jpg";